import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from 'design';

const AuthLink = styled(Link)`
  font-weight: ${theme.font.weight.semiBold};
  color: ${theme.color.primary[500]};

  &:hover,
  &:visited {
    color: ${theme.color.primary[500]};
  }
`;

export default AuthLink;
